import React from 'react';
import { Link } from 'react-router-dom';

const ServicesOverview = () => {
  return (
    <div>
      {/* Header Section */}
      <section
        className="hero-section min-h-[400px] flex items-center"
        style={{ backgroundImage: 'url(https://images.pexels.com/photos/1267361/pexels-photo-1267361.jpeg?auto=compress&cs=tinysrgb&w=1920)' }}
      >
        <div className="hero-overlay w-full min-h-[400px] flex items-center">
          <div className="container mx-auto px-4 text-white">
            <h1 className="text-5xl font-bold mb-4">Our Services</h1>
            <p className="text-xl text-gray-200">Comprehensive Equipment Solutions for Process Industries</p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4 section-title inline-block">ATHENA Has Expertise In</h2>
            <p className="text-xl text-gray-600 mt-8">From design to installation, we deliver excellence</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {/* Evaporators */}
            <Link to="/services/evaporators" className="card-hover bg-gray-50 rounded-lg p-8 border-2 border-transparent hover:border-accent">
              <div className="text-5xl mb-4 text-accent">⚙️</div>
              <h3 className="text-2xl font-bold mb-4">Evaporators</h3>
              <p className="text-gray-600 mb-4">
                Comprehensive range of evaporators for various industrial applications
              </p>
              <ul className="text-sm text-gray-700 space-y-2 feature-list">
                <li>Falling Film Evaporators</li>
                <li>Forced Recirculation Evaporator</li>
                <li>Scrapped Surface Evaporator</li>
                <li>Wiped Film Evaporator</li>
                <li>Agitated Thin Film Evaporator</li>
                <li>Batch Type Evaporators</li>
              </ul>
              <div className="mt-6 text-green font-semibold">Learn More →</div>
            </Link>

            {/* Dryers */}
            <Link to="/services/dryers" className="card-hover bg-gray-50 rounded-lg p-8 border-2 border-transparent hover:border-accent">
              <div className="text-5xl mb-4 text-accent">🌪️</div>
              <h3 className="text-2xl font-bold mb-4">Dryers</h3>
              <p className="text-gray-600 mb-4">
                Advanced drying solutions for powder and solid products
              </p>
              <ul className="text-sm text-gray-700 space-y-2 feature-list">
                <li>Spray Dryer</li>
                <li>Fluid Bed Dryer</li>
                <li>Vacuum Band Dryer</li>
                <li>Vacuum Tray Dryer</li>
                <li>Ring Dryer</li>
                <li>Rotary Dryer & Roller Dryer</li>
                <li>Flash Dryer & Agitated Thin Film Dryer</li>
              </ul>
              <div className="mt-6 text-green font-semibold">Learn More →</div>
            </Link>

            {/* Dairy Equipment */}
            <Link to="/services/dairy-equipment" className="card-hover bg-gray-50 rounded-lg p-8 border-2 border-transparent hover:border-accent">
              <div className="text-5xl mb-4 text-accent">🥛</div>
              <h3 className="text-2xl font-bold mb-4">Dairy Equipment</h3>
              <p className="text-gray-600 mb-4">
                Complete range of equipment for dairy processing
              </p>
              <ul className="text-sm text-gray-700 space-y-2 feature-list">
                <li>Road Milk Tanker</li>
                <li>Milk Storage Tanks & Silos</li>
                <li>Milk/Cream Pasteuriser</li>
                <li>Butter Churn & Ghee Boiler</li>
                <li>Khoa Pan & Cheese Kettle</li>
                <li>Bottle Sterilizer & more</li>
              </ul>
              <div className="mt-6 text-green font-semibold">Learn More →</div>
            </Link>

            {/* Mixers */}
            <Link to="/services/mixers" className="card-hover bg-gray-50 rounded-lg p-8 border-2 border-transparent hover:border-accent">
              <div className="text-5xl mb-4 text-accent">🌀</div>
              <h3 className="text-2xl font-bold mb-4">Mixers</h3>
              <p className="text-gray-600 mb-4">
                Industrial mixing solutions for uniform blending
              </p>
              <ul className="text-sm text-gray-700 space-y-2 feature-list">
                <li>Twin Shaft Mixer</li>
                <li>Paddle Mixer</li>
                <li>Turbo Blender</li>
                <li>Sigma Mixer</li>
                <li>Ribbon Blender</li>
              </ul>
              <div className="mt-6 text-green font-semibold">Learn More →</div>
            </Link>

            {/* Accessories */}
            <Link to="/services/accessories" className="card-hover bg-gray-50 rounded-lg p-8 border-2 border-transparent hover:border-accent">
              <div className="text-5xl mb-4 text-accent">🔧</div>
              <h3 className="text-2xl font-bold mb-4">Miscellaneous Accessories</h3>
              <p className="text-gray-600 mb-4">
                Supporting equipment and components
              </p>
              <ul className="text-sm text-gray-700 space-y-2 feature-list">
                <li>Screw Conveyor</li>
                <li>Compactor</li>
                <li>Online Sieving System</li>
                <li>Milling Machine</li>
                <li>CIP Spray Nozzles</li>
                <li>Steam Radiators</li>
              </ul>
              <div className="mt-6 text-green font-semibold">Learn More →</div>
            </Link>

            {/* Herbal Extraction */}
            <Link to="/services/herbal-extraction" className="card-hover bg-gray-50 rounded-lg p-8 border-2 border-transparent hover:border-accent">
              <div className="text-5xl mb-4 text-accent">🌿</div>
              <h3 className="text-2xl font-bold mb-4">Herbal Extraction Equipment</h3>
              <p className="text-gray-600 mb-4">
                Specialized equipment for pharmaceutical and herbal applications
              </p>
              <ul className="text-sm text-gray-700 space-y-2 feature-list">
                <li>Extractors (Horizontal Rotary, Vertical)</li>
                <li>Columns (Molecular Sieve, Fractional)</li>
                <li>Filters (Agitated Nutch, Sparkler)</li>
                <li>Closed Loop Dryers</li>
                <li>Specialized Evaporators</li>
              </ul>
              <div className="mt-6 text-green font-semibold">Learn More →</div>
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose Our Equipment */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-4xl font-bold mb-12 text-center section-title inline-block">Why Choose Athena Equipment?</h2>
            <div className="grid md:grid-cols-2 gap-8 mt-12">
              <div className="bg-white p-6 rounded-lg">
                <h3 className="text-xl font-bold mb-3 text-accent">Quality & Certification</h3>
                <p className="text-gray-700">
                  All equipment manufactured under ISO 9001:2015 & ISO 14001:2015 certified processes, ensuring the highest quality standards.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg">
                <h3 className="text-xl font-bold mb-3 text-accent">Energy Efficiency</h3>
                <p className="text-gray-700">
                  Designed for optimal energy consumption, reducing operational costs and environmental impact.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg">
                <h3 className="text-xl font-bold mb-3 text-accent">Custom Solutions</h3>
                <p className="text-gray-700">
                  Equipment tailored to your specific requirements, ensuring perfect fit for your operations.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg">
                <h3 className="text-xl font-bold mb-3 text-accent">Expert Support</h3>
                <p className="text-gray-700">
                  24+ years of industry experience with comprehensive installation and commissioning support.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-black text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-4">Need Custom Equipment Solutions?</h2>
          <p className="text-xl mb-8 text-gray-300">
            Our engineering team is ready to design the perfect solution for your needs
          </p>
          <Link to="/contact" className="btn-primary px-10 py-4 rounded-lg text-lg font-semibold inline-block">
            Request a Quote
          </Link>
        </div>
      </section>
    </div>
  );
};

export default ServicesOverview;